<template>
  <div>
    <portal to="app-header">
      {{$t('partstatusmanagement.title')}}
    </portal>
    <div style="width: 700px;" class="d-flex">
      <v-text-field
        class="ml-4"
        v-model="mainid"
        :label="$t('partstatusmanagement.table.mainid')"
        clearable
        @keyup.enter="getPartList(mainid)"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
      color="primary"
      class="mt-2"
      :loading="saving"
      :disabled="!mainid"
      @click="getPartList(mainid)"
      >
        <v-icon small left>{{ 'mdi-magnify' }}</v-icon>
        {{$t('partstatusmanagement.btn.search')}}
      </v-btn>
      <v-btn
      color="primary"
      class="mt-2 ml-4"
      :loading="saving"
      :disabled="partStatus.length === 0"
      outlined
      @click="showAddDialog = true"
      >
        <v-icon small left>{{ 'mdi-plus' }}</v-icon>
        {{$t('partstatusmanagement.btn.duplicateadd')}}
      </v-btn>
      <v-btn
      color="warning"
      class="mt-2 mx-4"
      :loading="saving"
      :disabled="partStatus.length === 0"
      outlined
      @click="showEditDialog = true"
      >
        <v-icon small left>{{ 'mdi-pencil' }}</v-icon>
        {{$t('partstatusmanagement.btn.edit')}}
      </v-btn>
      <v-btn
      color="error"
      class="mt-2"
      :loading="saving"
      :disabled="partStatus.length === 0"
      outlined
      @click="handleDelete"
      >
        <v-icon small left>{{ 'mdi-delete' }}</v-icon>
        {{$t('partstatusmanagement.btn.delete')}}
      </v-btn>
    </div>
    <single-grid
    :height="'70vh'"
    :headers="partStatusHeaders"
    :list="partStatusList"
    @callback="(item)=>{partStatus = item}"
    />
    <edit-partstatus
      :saving="saving"
      :showEditDialog="showEditDialog"
      :partstatusselected="partStatus[0]"
      @cancel="showEditDialog = false"
      @edit="edit"
    />
    <add-partstatus
      :saving="saving"
      :showAddDialog="showAddDialog"
      :partstatusselected="partStatus[0]"
      @cancel="showAddDialog = false"
      @add="add"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import SingleGrid from '../components/SingleGrid.vue';
import EditPartstatus from '../components/EditPartstatus.vue';
import AddPartstatus from '../components/AddPartstatus.vue';

export default {
  name: 'PartstatusManagement',
  data() {
    return {
      mainid: '',
      partStatus: [],
      partStatusList: [],
      partStatusHeaders: [],
      partStatusTags: [
        'mainid',
        'substationid',
        'substationname',
        'overallresult',
        'producttypename',
        'sublineid',
        'roadmapid',
        'createdTimestamp',
        'linename',
        'lineid',
        'carrierid',
        'producttypename',
        'recipename',
        'productid',
        'packagebatchid',
        'ordername',
        'ordernumber',
        'ordertype',
        'customername',
        'checkoutngcode',
        'completedproductid',
        'nexttargetstation',
        'modestatus',
      ],
      saving: false,
      showEditDialog: false,
      showAddDialog: false,
    };
  },
  created() {
    this.init();
  },
  components: {
    SingleGrid,
    EditPartstatus,
    AddPartstatus,
  },
  methods: {
    ...mapMutations('helper', ['setAlert']),
    ...mapActions('partstatusManagement', ['getElement', 'postElement', 'updateElement', 'deleteElement']),
    async getPartList(mainid) {
      this.saving = true;
      console.log(mainid);
      const partstatuslist = await this.getElement({
        elementname: 'partstatus',
        query: `?searchquery=${mainid}`,
      });
      this.saving = false;
      this.partStatusList = partstatuslist;
      console.log(partstatuslist, 'partstatuslist');
    },
    async init() {
      this.partStatusHeaders = this.partStatusTags.map((tag, k) => ({
        headerName: this.$t(`partstatusmanagement.table.${tag}`),
        // headerName: tag,
        field: tag,
        filter: 'agTextColumnFilter',
        // headerCheckboxSelection: k === 0 && true,
        checkboxSelection: k === 0 && true,
        // initialSort: k === 0 && 'asc',
      }));
    },
    edit() {
      this.showEditDialog = false;
      this.partStatus = [];
      this.getPartList(this.mainid);
    },
    add() {
      this.showAddDialog = false;
      this.partStatus = [];
      this.getPartList(this.mainid);
    },
    async handleDelete() {
      if (await this.$root.$confirm.open(
        this.$t('partstatusmanagement.alert.deletetitle'),
        this.$t('partstatusmanagement.alert.deletecontent'),
      )) {
        this.saving = true;
        const payload = {
          elementname: 'partstatus',
          id: this.partStatus[0]._id,
        };
        await this.deleteElement(payload);
        this.setAlert({
          show: true,
          type: 'error',
          message: 'Delete_SUCCESS',
        });
        this.saving = false;
        this.getPartList(this.mainid);
      }
    },
  },
};
</script>
